/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { SessionResponseOutput } from '../model';

import { validatedFetch } from '../../client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSessionUrl = () => {
  return `/api/v1/session`;
};

export const session = async (
  options?: Parameters<typeof validatedFetch>[1],
): Promise<SessionResponseOutput> => {
  return validatedFetch<SessionResponseOutput>(getSessionUrl(), {
    ...options,
    method: 'GET',

    schema: SessionResponseOutput,
  });
};

export const getSessionQueryKey = () => {
  return [`/api/v1/session`] as const;
};

export const getSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof session>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof session>>, TError, TData>;
  request?: SecondParameter<typeof validatedFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSessionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof session>>> = ({ signal }) =>
    session({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof session>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SessionQueryResult = NonNullable<Awaited<ReturnType<typeof session>>>;
export type SessionQueryError = unknown;

export function useSession<
  TData = Awaited<ReturnType<typeof session>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof session>>, TError, TData>;
  request?: SecondParameter<typeof validatedFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSessionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}
